var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhantomIconNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#6B758B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_501_407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#DEDEDE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_501_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.36659 19C4.91879 19 6.83681 16.6011 7.9814 14.7055C7.84221 15.1249 7.76488 15.5442 7.76488 15.9469C7.76488 17.0541 8.35264 17.8425 9.51277 17.8425C11.1059 17.8425 12.8074 16.3327 13.6891 14.7055C13.6272 14.9404 13.5963 15.1584 13.5963 15.3597C13.5963 16.1314 13.9985 16.6179 14.8182 16.6179C17.4014 16.6179 20 11.6692 20 7.3411C20 3.96924 18.4222 1 14.4625 1C7.5019 1 0 10.1929 0 16.1314C0 18.4632 1.16009 19 2.36659 19ZM12.0649 6.97204C12.0649 6.13327 12.498 5.54613 13.1323 5.54613C13.7509 5.54613 14.1841 6.13327 14.1841 6.97204C14.1841 7.81081 13.7509 8.41472 13.1323 8.41472C12.498 8.41472 12.0649 7.81081 12.0649 6.97204ZM15.3751 6.97204C15.3751 6.13327 15.8082 5.54613 16.4424 5.54613C17.0611 5.54613 17.4942 6.13327 17.4942 6.97204C17.4942 7.81081 17.0611 8.41472 16.4424 8.41472C15.8082 8.41472 15.3751 7.81081 15.3751 6.97204Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantomIconNew);
export default __webpack_public_path__ + "static/media/Phantom-icon-new.c33c93cd955bc6ffe04a064c5af4f24f.svg";
export { ForwardRef as ReactComponent };